const userPaths = {
  roles: '/admin/roles',
  newRole: '/admin/roles/new',
  editRole: (id = ':id') => `/admin/roles/${id}/edit`,
  users: '/admin/users',
  newUser: '/admin/users/new',
  editUser: (id = ':id') => `/admin/users/${id}/edit`,
  copyUser: (id = ':id') => `/admin/users/${id}/copy`,
  logs: '/admin/logs',
  plugins: '/admin/plugins',
  smtp: '/admin/plugins/smtp',
  fulfilmentHouse: '/admin/plugins/fulfillment-house',
  newSmtp: '/admin/plugins/smtp/new',
  newFulfilmentHouse: '/admin/plugins/fulfillment-house/new',
  editSmtp: (id = ':id') => `/admin/plugins/smtp/${id}/edit`,
  editFulfilmentHouse: (id = ':id') => `/admin/plugins/fulfillment-house/${id}/edit`,
  affiliates: '/admin/affiliate',
  adminAffiliates: '/admin/affiliate/affiliates',
  editAffiliate: (id = ':id') => `/admin/affiliate/affiliates/${id}/edit`,
  scrubSettings: '/admin/affiliate/scrub-settings',
  prepaidBins: '/admin/affiliate/prepaid-bins',
  blacklists: '/admin/blacklists',
  whitelists: '/admin/whitelists',
  testCards: '/admin/test-cards',
  webhooks: '/admin/webhooks',
  newWebhook: '/admin/webhooks/new',
  editWebhook: (id = ':id') => `/admin/webhooks/${id}/edit`,
};
export default userPaths;
